





































import { Component, Vue, Prop } from "vue-property-decorator";
import { ContactModel } from "../models";

@Component
export default class ContactsTable extends Vue {
  @Prop({ required: true })
  value!: ContactModel[];

  get items() {
    return this.value.sort((a, b) => {
      if (a.main_contact > b.main_contact) {
        return -1;
      }
      if (a.main_contact < b.main_contact) {
        return 1;
      }
      return 0;
    });
  }

  pagination = {
    descending: true,
    rowsPerPage: -1,
    sortBy: undefined
  };

  headers = [
    { text: "", value: "main_contact", sortable: false },
    { text: this.t("firstName"), value: "first_name" },
    { text: this.t("lastName"), value: "last_name" },
    { text: this.t("access"), value: "access" },
    { text: this.t("emailAddress"), value: "email_address" },
    { text: this.t("phoneNumber"), value: "phone_number" },
    { text: this.t("mobilePhoneNumber"), value: "mobile_phone_number" }
  ];

  private t(key: string): string {
    return this.$t("relationprofile.table." + key).toString();
  }
}
